//--
import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums/request-enums';
//#region comment metod
const PostGetOrder = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.PostGetOrder,
        method: RequestType.POST,
        data,
    });
const PostOrdersNotFinance = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.PostOrdersNotFinance,
        method: RequestType.POST,
        data,
    });
const UpdateOrderActionRules = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.UpdateOrderActionRules,
        method: RequestType.POST,
        data,
    });
const GetOrderDetail = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.GetOrderDetail,
        method: RequestType.POST,
        data,
    });
const GetSaleOrderShippingBillingAddress = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.GetSaleOrderShippingBillingAddress,
        method: RequestType.POST,
        data,
    });
const GetOrderInformation = (data: {
    CustomerId: number;
    OrderNumber: string;
    CultureCode: string;
    MobileVersionCode: string;
    BackofficeTypeId: number;
}): Promise<any> =>
    request({
        url: ApiURL.Command.GetOrderInformation,
        method: RequestType.POST,
        data,
    });
const UpdateSaleOrderAddress = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.UpdateSaleOrderAddress,
        method: RequestType.POST,
        data,
    });
const UpdateShippingListCancelReason = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.UpdateShippingListCancelReason,
        method: RequestType.POST,
        data,
    });
const GetReturnDetailByOrderId = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.GetReturnDetailByOrderId,
        method: RequestType.POST,
        data,
    });
const InsertShippingListCancelReasons = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.InsertShippingListCancelReasons,
        method: RequestType.POST,
        data,
    });
const GetCrossShipmentList = (shippingListId: any): Promise<any> =>
    request({
        url: ApiURL.Command.GetCrossShipmentList + '?shippingListId=' + shippingListId,
        method: RequestType.GET,
    });
const GetOrderAllRefundDetails = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.GetOrderAllRefundDetails,
        method: RequestType.POST,
        data,
    });
const UpdateShippingStatus = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.UpdateShippingStatus,
        method: RequestType.PUT,
        data,
    });
const CancelOrderStatus = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.CancelOrderStatus,
        method: RequestType.POST,
        data,
    });
const SaveShippingListStatusByRole = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.SaveShippingListStatusByRole,
        method: RequestType.POST,
        data,
    });
const StoreDeliveryOrders = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.StoreDeliveryOrders,
        method: RequestType.POST,
        data,
    });
const EstimatedShippedDateByRule = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.EstimatedShippedDateByRule,
        method: RequestType.POST,
        data,
    });
const UpdateEstimatedShippedDateForLCWByRule = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.UpdateEstimatedShippedDateForLCWByRule,
        method: RequestType.POST,
        data,
    });
const UpdateEstimatedShippedDateForMPByRule = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.UpdateEstimatedShippedDateForMPByRule,
        method: RequestType.POST,
        data,
    });
const UpdateEstimatedDeliveryDateEnabledForMP = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.UpdateEstimatedDeliveryDateEnabledForMP,
        method: RequestType.POST,
        data,
    });
const ReshipShipment = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.ReshipShipment,
        method: RequestType.POST,
        data,
    });

const BulkUpdateShipmentStateExcel = (formData: FormData): Promise<any> =>
    request({
        url: ApiURL.Command.BulkUpdateShipmentStateExcel,
        method: RequestType.POST,
        data: formData,
        // boundary'nin axios tarafından eklenmesi için Content-Type set etme
        skipContentType: true,
    });

const OrderCommand = {
    PostGetOrder,
    PostOrdersNotFinance,
    UpdateOrderActionRules,
    GetOrderDetail,
    GetSaleOrderShippingBillingAddress,
    GetOrderInformation,
    UpdateSaleOrderAddress,
    UpdateShippingListCancelReason,
    InsertShippingListCancelReasons,
    GetCrossShipmentList,
    GetOrderAllRefundDetails,
    GetReturnDetailByOrderId,
    UpdateShippingStatus,
    CancelOrderStatus,
    SaveShippingListStatusByRole,
    StoreDeliveryOrders,
    EstimatedShippedDateByRule,
    UpdateEstimatedShippedDateForLCWByRule,
    UpdateEstimatedShippedDateForMPByRule,
    UpdateEstimatedDeliveryDateEnabledForMP,
    ReshipShipment,
    BulkUpdateShipmentStateExcel,
};

export default OrderCommand;
